import { jsx as _jsx } from "react/jsx-runtime";
import { Center } from '@chakra-ui/react';
import { useT } from '@kcast-fe/core';
export const BoundaryFallback = () => {
    const { t } = useT();
    return _jsx(Center, { h: 'full', children: t('errors.wentWrong') });
};
//# sourceMappingURL=BoundaryFallback.js.map